// extracted by mini-css-extract-plugin
export default {"orSep":"styles-module--orSep--6aed5"};